import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { setupListeners } from '@reduxjs/toolkit/query';

// Example slices
import authSlice from './slice/auth.slice';
// import criticalActivitiesSlice from './slice/criticalActivities.slice'
import authApi from '../services/authService';
import profileApi from '../services/profileService';
import headerApi from '../services/headerService';
import roleReviewApi from '../services/roleReviewService';
import { reportApi } from '../services/reportService';
import { userreportAPI } from '../services/user-reportService';
import { managerApi } from '../services/managerService';
// Combine reducers
const rootReducer = combineReducers({
  auth: authSlice,
//   criticalActivitiesSlice:criticalActivitiesSlice,
  [authApi.reducerPath]: authApi.reducer,
  [profileApi.reducerPath]: profileApi.reducer,
  [roleReviewApi.reducerPath]: roleReviewApi.reducer,
  [reportApi.reducerPath]: reportApi.reducer,
  [headerApi.reducerPath]:headerApi.reducer,
  [userreportAPI.reducerPath]:userreportAPI.reducer,
  [managerApi.reducerPath]:managerApi.reducer,
});

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'], // Specify slices to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(authApi.middleware, profileApi.middleware,roleReviewApi.middleware,reportApi.middleware,headerApi.middleware,userreportAPI.middleware,managerApi.middleware),
});

const persistor = persistStore(store);

// Enable listeners for queries or subscriptions
setupListeners(store.dispatch);

// Export store and persistor
export { store, persistor };
